import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import LoginPage from '../screens/auth/Login';
import AdminsRoutes from './AdminsRoutes'; // Import your admin routes
import UserRoutes from './UsersRoutes'; // Import your user routes

function isAuthenticated() {
  return localStorage.getItem('token') !== null;
}

function getUserRole() {
  let user = null;

  try {
    const userString = localStorage.getItem("user");
    user = JSON.parse(userString);
  } catch (error) {
    console.error("Error parsing user from localStorage:", error);
  }

  // Check if user and user.role are defined before accessing properties
  const isAdmin = user && user.role && user.role_id && user.role_id.name === "Admin";
  const isUser = user && user.role && user.role_id && user.role_id.name === "User";
  
  return { isAdmin, isUser };
}

function AppRoute() {
  const { isAdmin, isUser } = getUserRole();

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        {isAuthenticated() ? (
          <>
            {isAdmin && <Route path="/admin/*" element={<AdminsRoutes />} />}
            {isUser && <Route path="/user/*" element={<UserRoutes />} />}
            {/* Redirect to login if no role matches */}
            <Route path="*" element={<Navigate to="/" />} />
          </>
        ) : (
          <Route path="*" element={<LoginPage />} />
        )}
      </Routes>
    </Router>
  );
}

export default AppRoute;
